// @flow
const withdrawMap = (type: string) => {
  if (type === "VIWD") {
    return "DEB";
  }
  return type;
};

export default withdrawMap;
